import { faComment } from '@fortawesome/free-solid-svg-icons';
import { useEntryFormContext } from 'context/EntryFormContext';
import { Input } from 'components/Input';
import styles from 'pages/Schedule/CreateEntry/CreateEntry.scss';

export const CommentInput = () => {
  const { form } = useEntryFormContext();

  return (
    <Input
      className={styles.commentInput}
      value={form.values.comment}
      name='comment'
      placeholder='Коментарі'
      icon={faComment}
      onChange={form.handleChange}
      textarea
    />
  );
};
